import request from '@/utils/request'

// 常量
const api_name = '/app/article'

export default {
    // 列表
    getArticlePageList(page, limit, searchObj) {
        return request({
            // 接口路径
            url: `${api_name}/getArticlePageList/${page}/${limit}`,
            method: 'get', // 提交方式
            // 参数
            params: searchObj
        })
    },
    getArticlePageListByCategory(page, limit, searchObj) {
        return request({
            // 接口路径
            url: `${api_name}/getArticlePageListByCategory/${page}/${limit}`,
            method: 'get', // 提交方式
            // 参数
            params: searchObj
        })
    },
    getArticlePageListByTag(page, limit, searchObj) {
        return request({
            // 接口路径
            url: `${api_name}/getArticlePageListByTag/${page}/${limit}`,
            method: 'get', // 提交方式
            // 参数
            params: searchObj
        })
    },
    getOne(key) {
        return request({
            // 接口路径
            url: `${api_name}/getArticleDetail/${key}`,
            method: 'get', // 提交方式
        })
    },
    getArticleTagAndCategory(articleId) {
        return request({
            // 接口路径
            url: `${api_name}/getArticleTagAndCategory/${articleId}`,
            method: 'get', // 提交方式
        })
    }
}